import React, { useEffect, useState } from 'react';
import { Container, Dropdown, Nav, Navbar, Spinner } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import logo from "../../img/Logo-for-pddl.jpg";
import { HashLink as Link } from 'react-router-hash-link';
import './Menu.css';


const Menu = () => {
    const [logoSize, setlogoSize] = useState(false);
    const [barSize, setbarSize] = useState(false);
    const listenScrollEvent = () => {
        window.scrollY > 80 ? setlogoSize(true) : setlogoSize(false);
        window.scrollY > 80 ? setbarSize(true) : setbarSize(false);
    };
    useEffect(() => {
        window.addEventListener("scroll", listenScrollEvent);
        return () => {
        window.removeEventListener("scroll", listenScrollEvent);
        };
    }, []);

    return (
        <Navbar expand="lg" className={barSize ? 'navbar1' : 'navbar'} id="navbar" style={{zIndex: '100', position: "fixed", width: "100%", height: "70px"}}>
            <Container>
                <Navbar.Brand>
                    <NavLink to="/home">
                        <img src={logo} id={logoSize ? 'logo1' : 'logo'} alt=""/>
                    </NavLink>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <NavLink to="/home" className="items" id="items">
                        <li>Home</li>
                    </NavLink>
                    <NavLink to="/about" className="items" id="items">
                        <li>About Us</li>
                    </NavLink>
                    <Dropdown className="">
                            <Dropdown.Toggle variant="" className="ps-0 items" as="div">
                                <NavLink to="#" className="items m-0">
                                    Services
                                </NavLink>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Link to="/survey" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Digital Survey</Dropdown.Item>
                                </Link>
                                <NavLink to="/gis" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Geographical Information System (GIS)</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/soil" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Soil Engineering</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/arch" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Architectural Drawing & Structural Design</Dropdown.Item>
                                </NavLink>
                                <NavLink to="elec" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Electrical Design & Wearing</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/plumbing" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Plumbing</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/construction" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Construction</Dropdown.Item>
                                </NavLink>
                            </Dropdown.Menu>
                    </Dropdown> 
                    <Dropdown className="">
                            <Dropdown.Toggle variant="" className="ps-0 items" as="div">
                                <NavLink to="#" className="items m-0">
                                    Projects
                                </NavLink>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <NavLink to="/prevPro" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">Previous Projects</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/goPro" className="text-decoration-none menutext">
                                    <Dropdown.Item href="#/action-2">On Going Projects</Dropdown.Item>
                                </NavLink>
                            </Dropdown.Menu>
                    </Dropdown>
                    <NavLink to="/training" className="items" id="items">
                        <li>Training</li>
                    </NavLink>
                    <NavLink to="/clients" className="items" id="items">
                        <li>Clients</li>
                    </NavLink>
                    <Link to="/home#contact" className="items" id="items">
                        <li>Contact Us</li>
                    </Link>
                    {/* <Dropdown className="">
                            <Dropdown.Toggle variant="" className="ps-0 items" as="div">
                                <NavLink to="#" className="items m-0">
                                    More
                                </NavLink>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <NavLink to="/aboutBornali" className="text-decoration-none">
                                    <Dropdown.Item href="#/action-2">Bornali</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/aboutDDAC" className="text-decoration-none">
                                    <Dropdown.Item href="#/action-2">DDAC</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/aboutDUET" className="text-decoration-none">
                                    <Dropdown.Item href="#/action-2">DUET</Dropdown.Item>
                                </NavLink>
                            </Dropdown.Menu>
                    </Dropdown> */}
                    
                    
                    
                </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Menu;